import axios from 'axios';
import { ApiResponse, AuthResponse, userType } from '@/types/common';

export const getCookie = (params: object): ApiResponse<AuthResponse> => {
  return axios.post('api/auth/login', params);
};

export const getUser = (params: object): ApiResponse<AuthResponse> => {
  return axios.post('api/auth/login', params);
};

export const refreshUser = (params: {
  refresh_token: string;
}): ApiResponse<AuthResponse> => {
  return axios.post('api/auth/refresh', null, { params });
};

export const getDataUser = (): ApiResponse<userType> => {
  return axios.get('api/auth/me');
};
export const userRegistration = (params: object): ApiResponse<AuthResponse> => {
  return axios.post('api/auth/register', params);
};

export const getRecoverCode = (params: { email: string }): ApiResponse<any> => {
  return axios.get(`api/auth/recovery-code?email=${params.email}`);
};

export const getVerifyCode = (): ApiResponse<any> => {
  return axios.get('api/auth/verify-code');
};

export const recoveryAccount = (params: object): ApiResponse<AuthResponse> => {
  return axios.post('api/auth/recovery-account', params);
};

export const changePassword = (params: object): ApiResponse<AuthResponse> => {
  return axios.post('api/auth/change-password', params);
};

export const verifyAccount = (params: object): ApiResponse<any> => {
  return axios.post('api/auth/verify-account', params);
};

export const removeUser = (): ApiResponse<any> => {
  return axios.delete('api/auth/');
};
